import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PublicModule } from '../../../../app/public/public-module';

@Component({
  selector: 'app-error-layout',
  standalone: true,
  imports: [PublicModule, RouterOutlet],
  template: `
    <app-header />
    <router-outlet />
    <app-footer />
  `,
})
export class ErrorLayoutComponent {}
